exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-treeview-node__label{font-size:1rem;margin-left:6px;flex-grow:1;flex-shrink:0}", ""]);

// exports
